/// <amd-module name="Wit/DeliveryPlans/Common/Constants" />

export const enum FieldRefNames {
    StartDate = "Microsoft.VSTS.Scheduling.StartDate",
    TargetDate = "Microsoft.VSTS.Scheduling.TargetDate",
    StackRank = "Microsoft.VSTS.Common.StackRank"
}

/**
 * Fields that don't exist on the server but are used to pass data around on the client
 */
export const enum ClientFields {
    HasDependencyError = "HasDependencyError",
    HasDependency = "HasDependency"
}

export namespace Features {
    export const VirtualizeTimeline = "WebAccess.DeliveryPlans.VirtualizeTimeline";
}
